import React, { FC } from "react";

import Logo from "@components/common/Logo";
import { useSidebarStateStore } from "@store/sidebar";
import { Box } from "@components/base";
import { useGetCurrentCompanyInfo } from "@api";
import DownloadPreview from "@components/common/DownloadPreview";
import { useUserStore } from "@store/user";

const UserSidebarLogo: FC = () => {
  const { sidebarCollapsed } = useSidebarStateStore();
  const { user } = useUserStore();
  const { currentCompanyInfo } = useGetCurrentCompanyInfo(user);
  const customLogo = currentCompanyInfo?.appearance?.logo;

  return (
    <Box height={110} display="flex" justifyContent="center">
      {!customLogo && <Logo type={sidebarCollapsed ? "small" : "green0meter"} />}
      {customLogo && (
        <Box
          width={sidebarCollapsed ? 60 : 120}
          height={sidebarCollapsed ? 80 : 120}
          textAlign="center"
        >
          <DownloadPreview path={customLogo.path} name={customLogo.name} />
        </Box>
      )}
    </Box>
  );
};

export default UserSidebarLogo;
